import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';

/** /organization — sends a tenant admin to their own tenant's admin page. */
export function OrganizationRedirect() {
  const { user } = useAuth();
  return user?.tenantId ? <Navigate to={`/tenants/${user.tenantId}`} replace /> : <Navigate to="/tenants" replace />;
}
